// assets
import { IconFiles, IconUpload, IconFolder, IconCloud, IconChartBar, IconSettings } from '@tabler/icons-react';

// constant
const icons = { IconFiles, IconUpload, IconFolder, IconCloud, IconChartBar, IconSettings };

// ==============================|| KHO LƯU TRỮ (Storage) ||============================== //

const storage = {
    id: 'storage',
    title: 'Kho lưu trữ',
    type: 'group',
    children: [
        {
            id: 'storage-module',
            title: 'Storage',
            type: 'collapse',
            icon: icons.IconFiles,
            children: [
                {
                    id: 'storage-dashboard',
                    title: 'Dashboard',
                    type: 'item',
                    url: '/storage/dashboard',
                    breadcrumbs: false
                },
                {
                    id: 'file-manager',
                    title: 'File Manager',
                    type: 'item',
                    url: '/storage/files',
                    breadcrumbs: false
                },
                {
                    id: 'upload-center',
                    title: 'Upload Center',
                    type: 'item',
                    url: '/storage/upload',
                    breadcrumbs: false
                },
                {
                    id: 'cloud-storage',
                    title: 'Cloud Storage',
                    type: 'item',
                    url: '/storage/cloud',
                    breadcrumbs: false
                },
                {
                    id: 'storage-analytics',
                    title: 'Analytics',
                    type: 'item',
                    url: '/storage/analytics',
                    breadcrumbs: false
                },
                {
                    id: 'storage-settings',
                    title: 'Settings',
                    type: 'item',
                    url: '/storage/settings',
                    breadcrumbs: false
                }
            ]
        }
    ]
};

export default storage;
